import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SideBar',{attrs:{"bar_name":"Chang Retail Register","user":_vm.user}}),_c(VMain,[_c(VContainer,[_c('iframe',{attrs:{"src":_vm.url,"height":_vm.window.height - 80,"width":"100%"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }